import {
    Avatar,
    Menu,
    MenuItemProps,
    useBreakpoints,
    useCdnAssets,
    useFileUrl,
    useRuntimeEnv,
    useRuntimeEnvRolesIncludes,
    useTranslation,
    useTranslationRoute,
    useUrlActive,
    useUserProfilePicture,
} from "@bsm/component";
import { useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import pkg from "../../../package.json";
import { useLeftSideBarMenu } from "./hooks/useLeftSideBarMenu";
import _ from "lodash";
import './css/navbar.css'

export const AdminLeftSideBar = (props: AdminLeftSideBarProps) => {

    const profilePictureUrl = useUserProfilePicture()
    const { runtimeEnv } = useRuntimeEnv();
    const roleIncludes = useRuntimeEnvRolesIncludes()
    const url = useTranslationRoute();
    const t = useTranslation();
    const menuItems = useLeftSideBarMenu();
    const { md } = useBreakpoints();
    const isActive = useUrlActive();

    
    const transformedMenuItems = useMemo(() => {
        return menuItems.map((menu) => {
            return {
                ...menu,
                items: menu.items?.filter((item) => _.isEmpty(item?.roles) || !!item?.roles?.every((role: string) => roleIncludes(role)))
            }
        }).filter((item) => !_.isEmpty(item.items))
    }, []);

    return (
        <aside
            className={`sidebar-left ${props.open ? "open" : ""}`}>
            <Link to="/">
                {!props.open && (
                    <img
                        src={`/assets/img/logo_cropped.png`}
                        alt="Logo"
                        className={`
                        absolute top-4 z-20
                        transition-all
                        left-5 h-14
                    `}
                    />
                )}
                {props.open && (
                    <img
                        src={`/assets/img/logo.png`}
                        alt="Logo"
                        className={`
                        absolute top-4 z-20
                        transition-all
                        left-3.5 h-14
                    `}
                    />
                )}
            </Link>
            <div
                className={`
                flex items-center flex-col justify-center py-10 text-xs tracking-wider gap-2
                mt-12 mb-4
                opacity-1 transition-all duration-150
                ${!props.open ? " opacity-0 h-6" : ""} 
                `}
            >
                <Link to={url(`admin/user/${runtimeEnv.user?.id}/about`)}>
                    <Avatar
                        src={profilePictureUrl(runtimeEnv?.user?.id!)}
                        fullName={runtimeEnv?.user?.fullName}
                        size="lg"
                    />
                </Link>
                <div className="flex flex-col gap-2 justify-center items-center">
                    <Link to={url(`admin/user/${runtimeEnv.user?.id}`)}>
                        <h6 className="text-center text-bold">
                            {runtimeEnv.user.fullName}
                        </h6>
                    </Link>
                    <Link
                        to={url(`admin/user/organisation/${runtimeEnv.organisation?.id}`)}
                    >
                        <span className="text-[#555]">
                            {runtimeEnv.organisation?.designation}
                        </span>
                    </Link>
                </div>
            </div>
            <div>
                <Menu
                    items={transformedMenuItems}
                    onlyStartIcon={!md && !props.open}
                    activeFn={(menu) => !!menu.link && isActive(menu.link)}
                />
            </div>
            <div className="mt-4 px-4 text-[12px] text-gray text-center absolute bottom-0 left-0 right-0">
                <a href="/">
                    {t(`Generic.de.${process.env.REACT_APP_NAME}`)}-
                    {pkg.version}
                </a>{" "}
                © {new Date().getFullYear()}
            </div>
        </aside>
    );
};

type AdminLeftSideBarProps = {
    open: boolean;
};
